import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { TypeRatingsModalPage } from './type-ratings-modal.page';

const routes: Routes = [
  {
    path: '',
    component: TypeRatingsModalPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [TypeRatingsModalPage]
})
export class TypeRatingsModalPageModule {}
